module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_2c2p":"Update 2c2p","merchant_id":{"label":"Merchant ID","placeholder":"Write your merchant id key here"},"secret_key":{"label":"Secret key","placeholder":"Write your secret key here"}}}')
  delete Component.options._Ctor
}
